<template>
  <div class="swiper-main" :class="{ 'swiper-main-mobile': isMobile}">
    <swiper ref="mySwiper" :options="swiperOptions">
      <slot></slot>
      <div slot="pagination" class="swiper-pagination" id="pagination"></div>
    </swiper>
  </div>
</template>
<script>
  import 'swiper/dist/css/swiper.css';
  import { swiper } from 'vue-awesome-swiper';
  export default {
    name: 'BaseSwiper',
    components: { swiper },
    props: {
      swiperOptions: {
        type: Object,
        default: () => {}
      },
      swiperList: {
        type: Array,
        default: () => []
      }
    }
  };
</script>
<style lang="scss" scoped>
  .swiper-main {
    width: 100%;
  }
</style>
